import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import {
  Box,
  Checkbox,
  Drawer,
  FilledInput,
  FormControl,
  InputAdornment,
  Popper,
  TextField,
  Typography,
} from "@mui/material";
import Autocomplete, { autocompleteClasses } from "@mui/material/Autocomplete";

import { getVendorContract } from "../../../../actions/company";

const StyledBoxSearch = styled(Box)({
  "& .label": {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 8,
    marginTop: 16,
  },
});

const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: "border-box",
    [`& .${autocompleteClasses.option}`]: {
      "&:hover": {
        backgroundColor: "#f6f7f8",
        margin: "0 8px",
        borderRadius: 8,
        paddingLeft: 8,
      },
    },
  },
});

const StyledAutocomplete = styled(Autocomplete)({
  width: "100%",
  border: 0,
  "& .MuiFilledInput-root": {
    backgroundColor: "#919eab14",
    height: 56,
    padding: "0px 12px",
    borderRadius: 8,
    "&.Mui-focused": {
      backgroundColor: "#919eab14",
    },
    "& .MuiInputAdornment-root": {
      width: 32,
      marginTop: "0!important",
      fontSize: 24,
      color: "#919EAB",
      "& i": {
        marginRight: 8,
      },
    },
    "& .MuiAutocomplete-endAdornment": {
      "& .MuiButtonBase-root": {
        fontSize: 14,
        width: 22,
        height: 22,
      },
    },
    "&:hover": {
      backgroundColor: "#919eab29",
      "&:before": {
        border: "none !important",
      },
    },
    "&::after": {
      border: "none",
    },
    "&::before": {
      border: "none",
    },
  },
});

const SelectVendor = (props) => {
  let { handleChange, readOnly, label, vendor } = props;
  let dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { result: companyContract } = useSelector(
    (state) => state.companyContract
  );

  useEffect(() => {
    dispatch(getVendorContract());
  }, []);

  return (
    <StyledBoxSearch>
      {label === false ? null : (
        <Typography className="label" color="text.third">
          {t("Company")}
        </Typography>
      )}

      <StyledAutocomplete
        options={companyContract || []}
        value={vendor}
        onChange={(event, newValue) => {
          handleChange(newValue);
        }}
        popupIcon={<i className="fa-light fa-chevron-down"></i>}
        getOptionLabel={(option) => option.vendorName}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="filled"
            placeholder={`${t("Select_Company")}`}
          />
        )}
        PopperComponent={StyledPopper}
        noOptionsText={`${t("No_Data")}`}
        readOnly={readOnly}
      />
    </StyledBoxSearch>
  );
};

export default SelectVendor;
